import { PrinterType } from '@shared/models/receipt-data';

// One-time plaintext credentials for the Epson Server Direct Print poll endpoint.
// Only present in the response right after generation; never stored/returned afterwards.
export interface PollCredentials {
    username: string;
    password: string;
}

export interface BcmNetworkPrinterDTO {
    id: number;
    name: string;
    location: string;
    ipv4: string;
    ipv6: string;
    port: number;
    note: string;
    printerType?: PrinterType;
    assignedUserIds?: string[];
    pollUsername?: string | null;
    pollCredentials?: PollCredentials;
}

export class BcmNetworkPrinter {
    id: number;
    name: string;
    location: string;
    ipv4: string;
    ipv6: string;
    port: number;
    note: string;
    printerType: PrinterType | null;
    assignedUserIds: string[];

    // Basic-Auth username the printer sends when polling (identifier, not secret).
    pollUsername: string | null;

    // Only set in the response immediately after (re)generation – contains the plaintext
    // password that must be transferred into the printer and is never shown again.
    pollCredentials?: PollCredentials | null;

    constructor(dto = {} as BcmNetworkPrinterDTO) {
        this.id = dto.id;
        this.name = dto.name;
        this.location = dto.location;
        this.ipv4 = dto.ipv4;
        this.ipv6 = dto.ipv6;
        this.port = dto.port;
        this.note = dto.note || '';
        this.printerType = dto.printerType ?? null;
        this.assignedUserIds = dto.assignedUserIds ?? [];
        this.pollUsername = dto.pollUsername ?? null;
        this.pollCredentials = dto.pollCredentials ?? null;
    }

    get isReceiptPrinter(): boolean {
        return this.printerType === 'epson' || this.printerType === 'giant';
    }
}
